export default "__VITE_ASSET__DijWvi4O__"